import {
  type OnboardingStepProps,
  OnboardingStepWrapper,
  type OnboardingStepWrapperProps,
} from "../OnboardingStepWrapper";
import { NameStep } from "./components/NameStep";

export function NamePage(
  props: Pick<OnboardingStepWrapperProps, "worker" | "progress" | "onBack" | "onNext" | "stage">
) {
  const { worker, progress, onBack, onNext, stage } = props;

  const stepProps = {
    worker,
    progress,
    stage,
    onNext,
    onBack,
  };

  return (
    <OnboardingStepWrapper
      {...stepProps}
      render={(props: OnboardingStepProps) => <NameStep {...props} />}
    />
  );
}
